__turbopack_context__.v({
  "DM_12_24_Link_B": "HealthStatusOverlay-module-scss-module__zbjRza__DM_12_24_Link_B",
  "DM_14_24_Link_B": "HealthStatusOverlay-module-scss-module__zbjRza__DM_14_24_Link_B",
  "DM_20_24_Bold": "HealthStatusOverlay-module-scss-module__zbjRza__DM_20_24_Bold",
  "DM_Body_Reg_16": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Body_Reg_16",
  "DM_Bold_14_16": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Bold_16_24",
  "DM_Bold_20_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Bold_20_24",
  "DM_Bold_40_56": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Btn_16_16_Med",
  "DM_Med_10_12": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_10_12",
  "DM_Med_12_12_Chip": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_12_12_Chip",
  "DM_Med_12_16": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_12_16",
  "DM_Med_14_16": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_14_16",
  "DM_Med_14_20": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_14_20",
  "DM_Med_14_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_14_24",
  "DM_Med_16_16": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_16_16",
  "DM_Med_16_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_16_24",
  "DM_Med_18_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_18_24",
  "DM_Med_20_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_20_24",
  "DM_Med_24_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_24_24",
  "DM_Med_32_32": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_32_32",
  "DM_Med_32_48": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_32_48",
  "DM_Med_8_8": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Med_8_8",
  "DM_Reg_10_10": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_12_16",
  "DM_Reg_14_16": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_14_16",
  "DM_Reg_14_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_16_20",
  "DM_Reg_16_24": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_18_28",
  "DM_Reg_32_32": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_32_32",
  "DM_Reg_40_56": "HealthStatusOverlay-module-scss-module__zbjRza__DM_Reg_40_56",
  "backdrop": "HealthStatusOverlay-module-scss-module__zbjRza__backdrop",
  "container": "HealthStatusOverlay-module-scss-module__zbjRza__container",
  "content": "HealthStatusOverlay-module-scss-module__zbjRza__content",
  "header": "HealthStatusOverlay-module-scss-module__zbjRza__header",
  "link": "HealthStatusOverlay-module-scss-module__zbjRza__link",
  "message": "HealthStatusOverlay-module-scss-module__zbjRza__message",
  "modal": "HealthStatusOverlay-module-scss-module__zbjRza__modal",
  "tile": "HealthStatusOverlay-module-scss-module__zbjRza__tile",
  "wider": "HealthStatusOverlay-module-scss-module__zbjRza__wider",
});
